import env from 'env'
const format = require('string-template')

const getters = {
    env: state => env,
    trans: (state) => {
        if (state.app.data) {
            return state.app.data.trans
        } else {
            return {
                labels: [],
                pages: [],
            }
        }
    },
    trans_p: (state, getters) => {
        return (file, key, placeholder) => {
            if (file && key && typeof placeholder === 'object') {
                var template = getters.trans[file][key]
                for (const [key, value] of Object.entries(placeholder)) {
                    template = template.replaceAll(':'+key, value)
                }
                return format(template, placeholder)
            }
            return ''
        }
    },
    bibles: (state) => {
        if (state.app.data) {
            return state.app.data.bibles
        } else {
            return null
        }
    },
    settings: (state) => {
        if (state.app.data) {
            return state.app.data.settings
        } else {
            return {
                page: {},
                modal: {},
            }
        }
    },
    route_auth_level(state) {
        return app => {
            return app.$router.currentRoute.meta.auth_level
        }
    },
    route_navbar(state) {
        return app => {
            return app.$router.currentRoute.meta.navbar
        }
    },
    csrf_token(state) {
        return document.getElementsByName('csrf-token')[0].content
    },
    auth_check: state => !! state.auth.user,
    auth_token: state => {
        return state.auth.user ? state.auth.user.token : null
    },
    auth_id: state => state.auth.user ? state.auth.user.id : null,
    auth_email: state => state.auth.user ? state.auth.user.email : '',
    auth_name: state => state.auth.user ? state.auth.user.name.trim() : '',
    auth_profile: state => state.auth.user ? state.auth.user.profile || {} : {},
    auth_pages: state => state.auth.user ? state.auth.user.pages || [] : [],
    auth_batches: state => state.auth.user ? state.auth.user.batches || {} : {},
    auth_level: state => state.auth.user ? state.auth.user.level : '000',
    auth_level_name: state => {
        if (!state.auth.user) {
            return '000'
        }
        switch (state.auth.user.level) {
            case '000':
                return 'None'
            case '100':
                return 'User'
            case '200':
                return 'Admin'
            default:
                return 'None'
        }
    },
    auth_uuid: state => state.auth.user ? state.auth.user.uuid : '',
    notification_queue: state => state.notification.queue,
    axios_queue: state => state.axios.queue,
    axios_queue_length: state => Object.keys(state.axios.queue).length,
}
export default getters


